import {AuthMockApi} from "app/mock-api/common/auth/api";
import {MessagesMockApi} from "app/mock-api/common/messages/api";
import {NavigationMockApi} from "app/mock-api/common/navigation/api";
import {NotificationsMockApi} from "app/mock-api/common/notifications/api";
import {ShortcutsMockApi} from "app/mock-api/common/shortcuts/api";
import {UserMockApi} from "app/mock-api/common/user/api";
import {VksktStatusMockApi} from "./common/visit-status/api";
import {ProjectMockApi} from "./dashboards/project/api";
import {CryptoMockApi} from "./dashboards/crypto/api";
import {FinanceMockApi} from "./dashboards/finance/api";
import {AnalyticsMockApi} from "./dashboards/analytics/api";
import {IconsMockApi} from "./ui/icons/api";
import {SearchMockApi} from "./common/search/api";
import {ActivitiesMockApi} from "./pages/activities/api";
import {EconsentMockApi} from "./common/econsent/api";
import { VisitStatus2MockApi } from "./common/visit-status-2/api";
import { VksktStatus3MockApi } from "./common/visit-status-3/api";
import { VisitSignaturesMockApi } from "./common/visit-signatures/api";

export const mockApiServices = [
    AuthMockApi,
    MessagesMockApi,
    NavigationMockApi,
    NotificationsMockApi,
    ShortcutsMockApi,
    UserMockApi,
    ProjectMockApi,
    CryptoMockApi,
    FinanceMockApi,
    AnalyticsMockApi,
    IconsMockApi,
    SearchMockApi,
    ActivitiesMockApi,
    EconsentMockApi,
    VksktStatusMockApi,
    VisitStatus2MockApi,
    VksktStatus3MockApi,
    VisitSignaturesMockApi
];
